module.exports = __webpack_public_path__ + "img/testDen.31ea0761.png";